module.exports = __webpack_public_path__ + "img/8-Thinking Cropped.8cd6499.png";